import { useState } from 'react'
import { Link } from 'react-router-dom'
import { API_BASE_URL } from '@/services/apiClient'

export function SupportPage() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [category, setCategory] = useState<'support' | 'feedback' | 'commercial'>('support')
  const [sent, setSent] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setErr(null)
    setLoading(true)
    try {
      const res = await fetch(`${API_BASE_URL}/api/public/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, message, category }),
      })
      if (!res.ok) {
        const j = await res.json().catch(() => ({}))
        throw new Error(j.error || `Error ${res.status}`)
      }
      setSent(true)
      setMessage('')
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-900 text-gray-900 dark:text-gray-100 px-4 py-10">
      <div className="max-w-lg mx-auto">
        <Link to="/" className="text-primary-600 dark:text-primary-400 text-sm hover:underline">
          ← Volver al inicio de sesión
        </Link>
        <h1 className="text-2xl font-bold mt-4 mb-2">Soporte y feedback</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
          Cuéntanos qué necesitas. Si el servidor tiene configurado un buzón de soporte, recibiremos tu mensaje por
          correo.
        </p>

        {sent && (
          <p className="mb-4 text-green-600 dark:text-green-400 text-sm">Mensaje enviado. Gracias.</p>
        )}

        <form onSubmit={submit} className="space-y-4 bg-white dark:bg-dark-800 rounded-xl border border-gray-200 dark:border-dark-600 p-6">
          {err && <p className="text-red-600 text-sm">{err}</p>}
          <div>
            <label className="block text-xs text-gray-500 mb-1">Email de contacto</label>
            <input
              type="email"
              required
              className="w-full border rounded-lg px-3 py-2 dark:bg-dark-700 dark:border-dark-600"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Tipo</label>
            <select
              className="w-full border rounded-lg px-3 py-2 dark:bg-dark-700 dark:border-dark-600"
              value={category}
              onChange={(e) => setCategory(e.target.value as typeof category)}
            >
              <option value="support">Soporte técnico</option>
              <option value="feedback">Sugerencia</option>
              <option value="commercial">Comercial</option>
            </select>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Mensaje (mín. 10 caracteres)</label>
            <textarea
              required
              minLength={10}
              className="w-full border rounded-lg px-3 py-2 dark:bg-dark-700 dark:border-dark-600 min-h-[140px]"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 rounded-lg bg-primary-600 text-white font-medium disabled:opacity-50"
          >
            {loading ? 'Enviando…' : 'Enviar'}
          </button>
        </form>

        <p className="mt-6 text-sm">
          <Link to="/pricing" className="text-primary-600 dark:text-primary-400 hover:underline">
            Ver planes y prueba gratuita
          </Link>
        </p>
      </div>
    </div>
  )
}
